
import { useState } from "react";
import toast from "react-hot-toast";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

function useVolunteer(setError,clearErrors){
    const devoteeData = JSON.parse(localStorage.getItem("devoteeData")) || null
    const [committeeArray, setCommitteeArray] = useState([]);
    const onSubmit = async (data) => {
        if (committeeArray.length == 0) {
          setError("committee", {
            type: "required",
            message: "Please Select Committee",
          });
        } else {
          clearErrors();
          const payload = {
            devotee_id: devoteeData?.user_id,
            volunteerType: data?.volunteerType,
            selectedCommittee: committeeArray,
            comment: data?.comment,
          };
    
          try {
            const response = await postApi(apiEndPoints.volunteer, payload);
            if (response?.data?.status === 0) {
              toast.error(response?.data?.message);
            } else if (response?.data?.status === 1) {
              toast.success(response?.data?.message);
            } else {
              toast.error("Something Went Wrong");
            }
          } catch (error) {
            toast.error(`Registration failed: , ${error}`);
          }
        }
      };
      return {
        onSubmit,
        devoteeData,
        committeeArray,
        setCommitteeArray,
      }

}
export default useVolunteer;